export const LiveChatClosedEvent = () => {
	return null
}
